export const blockIconsHardwareRouter = (
	<span className='material-symbols-outlined'>router</span>
);
